export default __webpack_public_path__ + "static/media/gfhero.a77d40d2.jpg";